export const GET_SITE_CONFIG_SUCCESS = 'GET_SITE_CONFIG_SUCCESS'
export const ADD_SITE_CONFIG_SUCCESS = 'ADD_SITE_CONFIG_SUCCESS'
export const UPDATE_SITE_CONFIG_SUCCESS = 'UPDATE_SITE_CONFIG_SUCCESS'

export const API_REQUEST_START = 'API_REQUEST_START'
export const API_REQUEST_SUCCESS = 'API_REQUEST_SUCCESS'
export const API_REQUEST_FAIL = 'API_REQUEST_FAIL'
